module.exports = __webpack_public_path__ + "static/media/logo.53e774f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 506
// module chunks = 0